import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import translations
import translationDE from "../src/locales/de.json";
import translationEN from "../src/locales/en.json";
import translationES from "../src/locales/es.json";
import translationFR from "../src/locales/fr.json";
import translationTR from "../src/locales/tr.json";
// 200 OK
// Configure i18next
i18n
  .use(initReactI18next)
  .use(LanguageDetector) // Add language detector
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      tr: {
        translation: translationTR,
      },
      fr: {
        translation: translationFR,
      },
      es: {
        translation: translationES,
      },
      de: {
        translation: translationDE,
      },
    },
    // Set options for language detector
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      lookupQuerystring: "lan",
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
